import { render, staticRenderFns } from "./WhyBuyFromArticle.vue?vue&type=template&id=e80c9b16&scoped=true&"
import script from "./WhyBuyFromArticle.vue?vue&type=script&lang=js&"
export * from "./WhyBuyFromArticle.vue?vue&type=script&lang=js&"
import style0 from "./WhyBuyFromArticle.vue?vue&type=style&index=0&id=e80c9b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80c9b16",
  null
  
)

export default component.exports